import{_ as a}from"./_baseHasIn.js";import{_ as r}from"./_hasPath.js";var s=a,o=r;var t=function(a,r){return null!=a&&o(a,r,s)};export{t as h};
